import { render, staticRenderFns } from "./ListTemplate.vue?vue&type=template&id=73035c86&scoped=true&"
import script from "./ListTemplate.vue?vue&type=script&lang=js&"
export * from "./ListTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ListTemplate.vue?vue&type=style&index=0&id=73035c86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73035c86",
  null
  
)

export default component.exports